
























































import {
  defineComponent,
  PropType,
  computed,
  watch,
  ref,
} from '@vue/composition-api';
import { Popup, Button, Loading } from '@hb/coffee';
import type { ConvergeAgreementItem } from '@/shared/agreement/types';
import { useCountDown } from '@/hooks/useCountDown';
import { openThirdPage } from '@/api/native/utils';
import { jumpToContractList } from '@/shared/utils/jumpTo';
import store from '@/store';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import type { AgreementsPopProps } from './types';
import { AgreementsPopEvents } from './event-names';
import { TP_AGREEMENT_POPUP_MODULE } from './tianqi';

export default defineComponent({
  name: 'AgreementsPop',
  components: {
    Popup,
    Button,
    Loading,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    agreementList: {
      type: Array as PropType<ConvergeAgreementItem[]>,
      default: () => [],
    },
    hasCreditRouteChannelAgreement: {
      type: Boolean,
      default: false,
    },
  },
  setup(
    props: AgreementsPopProps,
    { emit }: { emit: (event: string, ...args: any[]) => void },
  ) {
    /** 3秒倒计时(若存在征信协议) */
    const {
      countDown, showCountDown, startCountDown, clearCountDown,
    } = useCountDown(3, false);
    const hasNameAndIdCard = ref(false);
    const ubtCommonParams = computed(() => ({
      agreements: props.agreementList?.map((item) => item.name).join(','),
      hasNameAndIdCard: hasNameAndIdCard.value ? 1 : 0,
    }));

    const commonReportUbt = () => {
      ubtSetupModuleExpose(TP_AGREEMENT_POPUP_MODULE, {
        ...ubtCommonParams.value,
      });
    };

    const onAgreementClick = (item: ConvergeAgreementItem) => {
      /** 如果协议超过1条，则跳转列表页查看协议 */
      if (item.list.length > 1) {
        jumpToContractList(item.list);
      } else {
        openThirdPage(item.list[0].agreementUrl);
      }
    };
    // 处理弹窗显示状态更新
    const onUpdateShow = (value: boolean) => {
      emit(AgreementsPopEvents.UPDATE_SHOW, value);
    };

    /** 点击关闭按钮 */
    const onClose = () => {
      ubtSetupPageButton(TP_AGREEMENT_POPUP_MODULE, {
        ...ubtCommonParams.value,
        buttonName: '关闭',
      });
      clearCountDown();
      emit(AgreementsPopEvents.CLOSE);
      onUpdateShow(false);
    };

    /** 点击“我已阅读并同意”按钮 */
    const onConfirm = () => {
      ubtSetupPageButton(TP_AGREEMENT_POPUP_MODULE, {
        ...ubtCommonParams.value,
        buttonName: '同意',
      });
      clearCountDown();
      emit(AgreementsPopEvents.AGREEMENT_CONFIRMED);
      onUpdateShow(false);
    };

    // 监听征信协议和弹窗显示状态，控制倒计时
    const checkAndStartCountDown = async (): Promise<void> => {
      if (props.show) {
        const defaultSyncData = Promise.resolve({ hasNameAndIdCard: false });
        const data = await (store.state.base.syncUserInfoCache || defaultSyncData);

        hasNameAndIdCard.value = data.hasNameAndIdCard;

        ubtSetupModuleExpose(TP_AGREEMENT_POPUP_MODULE, {
          ...ubtCommonParams.value,
        });

        if (props.hasCreditRouteChannelAgreement) {
          startCountDown();
        }
      } else {
        clearCountDown();
      }
    };

    /** 监听是否存在-hasCreditRouteChannelAgreement */
    watch(
      () => props.hasCreditRouteChannelAgreement,
      checkAndStartCountDown,
      { immediate: true },
    );

    /** 监听弹窗显示状态-show */
    watch(
      () => props.show,
      checkAndStartCountDown,
      { immediate: true },
    );

    return {
      showCountDown,
      countDown,

      onUpdateShow,
      onClose,
      onConfirm,
      onAgreementClick,
    };
  },
});
